import React from 'react';

import { Link } from 'react-router';

import './search.css';

const SearchResultComponent = ({ suggestions, loading, onClick, query }) => (
  <div className="u-show-on-focus m-search-result-container mt2">
    {suggestions.map(result => (
      <Link
        key={result.id}
        className="m-search-result link"
        onClick={onClick}
        to={`/fotografer/${result.id}`}>
        <i className="fa fa-user-o pr1" />
        {result.name}
      </Link>
    ))}
    {loading && !suggestions.length && <span>Laster...</span>}
    {!loading && query.length > 1 && !suggestions.length && (
      <span>Ingen resultater...</span>
    )}
    {!loading && !query && !suggestions.length && (
      <span>Søk etter medlemmer</span>
    )}
    {!suggestions.length && (
      <div className="m-search-result-footer">
        <Link
          className="a-search-footer-link"
          to="/fotografer/"
          onClick={onClick}>
          {' '}
          <i className="fa fa-chevron-right" />
          Liste over fotografer
        </Link>
        <Link className="a-search-footer-link" to="/priser/" onClick={onClick}>
          {' '}
          <i className="fa fa-chevron-right" />
          Liste over priser
        </Link>
      </div>
    )}
  </div>
);

export default SearchResultComponent;



// WEBPACK FOOTER //
// ./src/components/SearchResultComponent.js